import { MouseWheelZoom } from 'ol/interaction';
import { MouseWheelZoomMode } from '../definitions';

export class PmaMouseWheelZoom extends MouseWheelZoom {

    constructor(options) {
        super(options);
        // if (!this.hasOwnProperty("deltaPerZoom_")) {
        if (!Object.prototype.hasOwnProperty.call(this, "deltaPerZoom_")) {
            throw "deltaPerZoom_ not found";
        }

        this.deltaPerZoom_ = options.deltaPerZoom;

        this.mode = MouseWheelZoomMode.normal;
    }

    setMode(mode) {
        let view = this.getMap().getView();
        // if (view.getResolutions() == null || view.getResolutions().length == 0) {
        //     return;
        // }

        if (mode == MouseWheelZoomMode.normal) {
            view.setConstrainResolution(false);
            this.constrainResolution_ = false;
            this.mode = mode;
        } else {
            view.setConstrainResolution(true);
            this.constrainResolution_ = true;
            this.mode = mode;
        }
    }

    getZoomDelta() {
        return this.deltaPerZoom_;
    }

    setZoomDelta(delta) {
        this.deltaPerZoom_ = Math.max(delta, 1);
    }

}